import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { createVendor } from './api';
import type { NewVendorInput } from './types';

export function useCreateVendor() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: NewVendorInput) => createVendor(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.procurement.vendors() });
    },
  });
}
